// Sopwith 3D - medals and ribbons.
//
// Copyright (C) 1984-2000 David L. Clark
// Copyright (C) 2001-2026 Simon Howard and SDL Sopwith contributors
// Copyright (C) 2026 Sopwith 3D contributors
//
// This program is free software; you can redistribute it and/or modify it
// under the terms of the GNU General Public License as published by the Free
// Software Foundation; either version 2 of the License, or (at your option)
// any later version. This program is distributed WITHOUT ANY WARRANTY.
//
// Ported from SDL Sopwith swinit.c. Awards are decided each time the player
// lands safely, from the flight score accumulated since take-off.

import type { Obj } from './types';

export const MEDAL_PURPLEHEART = 0; // returned home wounded by gunfire
export const MEDAL_COMPETENCE = 1; // did serious damage on one sortie
export const MEDAL_VALOUR = 2; // sustained bravery far from home

export const RIBBON_ACE = 0; // five planes shot down
export const RIBBON_TOPACE = 1; // twenty-five planes
export const RIBBON_PERFECT = 2; // finished a level with all planes
export const RIBBON_SERVICE = 3; // three productive sorties
export const RIBBON_COMPETENCE2 = 4; // second competence award
export const RIBBON_PREVALOUR = 5; // halfway to the valour medal

export const MEDAL_NAMES = ['Purple Heart', 'Competence Medal', 'Medal of Valour'];
export const RIBBON_NAMES = [
  'Ace',
  'Top Ace',
  'Perfect Stage',
  'Service Ribbon',
  'Competence Ribbon',
  'Valour Ribbon',
];

const SERVICE_KILLSCORE = 5;
const COMPETENCE_KILLSCORE = 25;
const VALOUR_PRELIMIT = 175;
const VALOUR_LIMIT = 250;
const MAX_MEDALS = 3;
const MAX_RIBBONS = 6;

function giveMedal(ob: Obj, id: number): void {
  const m = ob.score.medals;
  if (!m.includes(id) && m.length < MAX_MEDALS) {
    m.push(id);
  }
}

function giveRibbon(ob: Obj, id: number): void {
  const r = ob.score.ribbons;
  if (!r.includes(id) && r.length < MAX_RIBBONS) {
    r.push(id);
  }
}

/** Called on a safe landing: bank the sortie's achievements. */
export function getAwards(ob: Obj): void {
  const f = ob.flightscore;
  const sc = ob.score;

  if (f.combatwound) {
    giveMedal(ob, MEDAL_PURPLEHEART);
  }

  sc.planekills += f.planekills;
  if (sc.planekills >= 5) {
    giveRibbon(ob, RIBBON_ACE);
  }
  if (sc.planekills >= 25) {
    giveRibbon(ob, RIBBON_TOPACE);
  }

  if (f.killscore >= SERVICE_KILLSCORE) {
    sc.landings++;
  }
  if (sc.landings >= 3) {
    giveRibbon(ob, RIBBON_SERVICE);
  }

  if (f.killscore >= COMPETENCE_KILLSCORE) {
    if (!sc.medals.includes(MEDAL_COMPETENCE)) {
      giveMedal(ob, MEDAL_COMPETENCE);
    } else {
      giveRibbon(ob, RIBBON_COMPETENCE2);
    }
  }

  sc.valour += f.valour;
  if (sc.valour >= VALOUR_PRELIMIT) {
    giveRibbon(ob, RIBBON_PREVALOUR);
  }
  if (sc.valour >= VALOUR_LIMIT) {
    giveMedal(ob, MEDAL_VALOUR);
  }
}

/** Called when a level is cleared. */
export function getEndLevel(ob: Obj): void {
  getAwards(ob);
  if (ob.crashcnt === 0) {
    giveRibbon(ob, RIBBON_PERFECT);
  }
}
